import * as React from 'react';
import { SVGProps } from 'react';

const IconPhotoSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 1H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM3 12l2-3 2 2 3-4 3 5H3z" />
  </svg>
);
export default IconPhotoSizeS;
